module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg2.103d2544.jpg";